var _rect, _rect2, _path, _text, _path2, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeRunHero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    rx: 40,
    fill: "#71c7ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 290,
    width: 800,
    height: 160,
    fill: "#45a65a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 115 640 310 400 440 160 310Z",
    fill: "#c9975c"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 285,
    fontSize: 150
  }, "\u26BE")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m470 270 165-145",
    stroke: "#7b431f",
    strokeWidth: 35,
    strokeLinecap: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 405,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "sans-serif",
    fontSize: 58,
    fontWeight: 800
  }, "HOME RUN HERO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRunHero);
export default __webpack_public_path__ + "static/media/home_run_hero.c23d904c9497306c2b8095d9787af9f5.svg";
export { ForwardRef as ReactComponent };